import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import CompanyPageToolbar from '../../../components/admin_portal/company/CompanyPageToolbar'
import CompanyTable from '../../../components/admin_portal/company/CompanyTable'
import CreateCompany from '../../../components/admin_portal/company/CreateCompany'
import { isAuth } from '../../../helpers/cookies';
import { SUPER_ADMIN, ADDNECTAR_ADMIN } from '../../../helpers/constants';

export class CompanyContainer extends Component {
  componentDidMount() {
    if ([SUPER_ADMIN, ADDNECTAR_ADMIN].includes(isAuth().role)) {
      this.props.get_company_list();
      this.props.get_process_list({ limit: 1000 });
    }
  }

  handleCompanyModal = (newVal, c_action) => {
    this.props.setCompanyModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleCompanyUpdateModal = async (newVal, c_action, company_id) => {
    let res = await this.props.get_company_details(company_id)
    await this.props.get_company_process(company_id);
    if (res && !res.error) {
      this.props.setCompanyModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(company_id)
    }
  };

  handleCompanySubmit = async (payload) => {
    let res = await this.props.create_company(payload);
    return res;
  };

  handleCompanyUpdate = async (payload) => {
    let res = await this.props.update_company(payload);
    return res;
  };

  handleActivateDeactivateCompany = async (payload) => {
    let res = await this.props.activate_deactivate_company(payload);
    return res;
  };

  handleAssignProcessCompany = async (payload) => {
    let res = await this.props.assign_process_company(payload);
    return res;
  };

  render() {
    const {
      is_company_modal_open,
      common_loading,
      total_company_count,
      page,
      c_action,
      company_id,
      selected_data,
      process_list,
      assign_process,
      company_process

    } = this.props;

    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: CompanyPageToolbar,
      }} title={""} sx={{
        '& .css-lc31tn > .MuiTypography-h4': {
          fontSize: '14px',
          alignSelf: { md: 'center', xs: 'flex-start' },
        },
        '& .css-lc31tn': {
          bgcolor: theme => theme.palette.grey[200],
          px: 1.5,
          py: 0.1,
          borderRadius: '10px',
          my: 1.5,
          flexDirection: { md: 'row', xs: 'column' },
          alignItems: { md: 'unset', xs: 'flex-start' }
        },
        '& .css-1hwxlk6': {
          width: { md: 'unset', xs: '100%' },
          flexDirection: { md: 'row', xs: 'column' },
          marginLeft: { md: 'auto', xs: 'unset!important' }
        },
      }}>
        <CompanyTable
          total_company_count={total_company_count}
          is_loading={common_loading}
          page={page}
          is_company_modal_open={is_company_modal_open}
          handleCompanyUpdateModal={this.handleCompanyUpdateModal}
          activate_deactivate_company={this.handleActivateDeactivateCompany}
          assign_process_company={this.handleAssignProcessCompany}
        />
        <CreateCompany
          is_company_modal_open={is_company_modal_open}
          handleCompanyModal={this.handleCompanyModal}
          handleProcessOption={this.handleProcessOption}
          handleCompanySubmit={this.handleCompanySubmit}
          handleCompanyUpdate={this.handleCompanyUpdate}
          handleAssignProcessCompany={this.handleAssignProcessCompany}
          is_loading={common_loading}
          c_action={c_action}
          company_id={company_id}
          selected_data={selected_data}
          process_list={process_list}
          assign_process={assign_process}
          company_process={company_process}
        />
      </PageContainer>
    )
  }
}

export default CompanyContainer

